.overlayContainer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: visible;
}

.insightIconWrapper {
  position: absolute;
  transform: translateX(-50%);
  pointer-events: auto;
  z-index: 1;
}
